import React, { useEffect } from "react"
import firebase from "gatsby-plugin-firebase";

import '../assets/bootstrap/css/bootstrap.css'; 
// import '../assets/css/dashboard.css'; 

import LeftSidebar from "../components/left-sidebar";
import RightSidebar from "../components/right-sidebar";
import { setUser, setUserMData } from "../helpers/auth";
import { navigate } from "gatsby";
import { getUserMetaData } from "../helpers/firebase";


const Layout = ({ children }) => {
    useEffect(() => {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                setUser(user);
                getUserMetaData(user.uid);
            } else {
                setUser({});
                setUserMData({});
                navigate('/');
            }
        })
    });

    return (
        <div className="container-fluid">
            <div className="row main_container">
                <LeftSidebar />
                <div className="col-md-6 center_container">
                    {children}
                </div>
                <RightSidebar />
            </div>
        </div>
    ) 
}

export default Layout
